// @flow

import {
  DESELECT_FILTER_ENTITIES,
  RESET_SELECTED_FILTERS,
  SET_AVAILABLE_FILTER_ENTITIES, SET_PRODUCT_CONFIGURATIONS, SET_SELECTED_CUSTOMER_GROUPS,
  SET_SELECTED_MODALITIES, SET_SELECTED_PRODUCT_COLLECTIONS,
  SET_SELECTED_REGIONS, SET_SELECTED_TERMS
} from './mutation-types'
import type { SelectionState } from './state'
import type { SelectionFilterEntitySet } from '../../../types/selection-filter-entity-set'
import type { CustomerGroup } from '../../../types/filter-entity/customer-group'
import type { ProductCollection } from '../../../types/filter-entity/product-collection'
import type { Modality } from '../../../types/filter-entity/modality'
import type { Entity } from '../../../types/filter-entity/entity'
import type { Region } from '../../../types/filter-entity/region'
import type { Term } from '../../../types/filter-entity/term'
import ProductConfiguration from '../../../types/product-configuration'
import { buildEmptyFilterSelection } from '../../../types/filter-selection'

export default {
  [SET_AVAILABLE_FILTER_ENTITIES]: (state: SelectionState, value: SelectionFilterEntitySet) => {
    state.availableFilterEntities = value
  },
  [SET_SELECTED_CUSTOMER_GROUPS]: (state: SelectionState, value: CustomerGroup[]) => {
    state.selectedFilterEntities = { ...state.selectedFilterEntities, customerGroups: value }
  },
  [SET_SELECTED_PRODUCT_COLLECTIONS]: (state: SelectionState, value: ProductCollection[]) => {
    state.selectedFilterEntities = { ...state.selectedFilterEntities, productCollections: value }
  },
  [SET_SELECTED_MODALITIES]: (state: SelectionState, value: Modality[]) => {
    state.selectedFilterEntities = { ...state.selectedFilterEntities, modalities: value }
  },
  [SET_SELECTED_REGIONS]: (state: SelectionState, value: Region[]) => {
    state.selectedFilterEntities = { ...state.selectedFilterEntities, regions: value }
  },
  [SET_SELECTED_TERMS]: (state: SelectionState, value: Term[]) => {
    state.selectedFilterEntities = { ...state.selectedFilterEntities, terms: value }
  },
  [DESELECT_FILTER_ENTITIES]: (state: SelectionState, deselectedEntities: Entity[]) => {
    const entityFilter = entity => !deselectedEntities.find(deselectedEntity => deselectedEntity.id === entity.id)
    state.selectedFilterEntities = {
      ...state.selectedFilterEntities,
      customerGroups: state.selectedFilterEntities.customerGroups.filter(entityFilter),
      productCollections: state.selectedFilterEntities.productCollections.filter(entityFilter),
      modalities: state.selectedFilterEntities.modalities.filter(entityFilter),
      regions: state.selectedFilterEntities.regions.filter(entityFilter)
    }
  },
  [RESET_SELECTED_FILTERS]: (state: SelectionState) => {
    state.selectedFilterEntities = buildEmptyFilterSelection()
  },
  [SET_PRODUCT_CONFIGURATIONS]: (state: SelectionState, value: ProductConfiguration[]) => {
    state.productConfigurations = value
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/selection/mutations.js